//@flow
import * as Immutable from 'immutable';

import createBaseEntityReducer from 'common/redux/reducers/baseEntityReducer';

import SkillActions from 'common/redux/actions/skill';

import { Skill } from 'common/models/internal/Skill';

import type { ActionType } from 'common/redux/reducers/baseEntityReducer';

const baseReducer = createBaseEntityReducer(SkillActions, Skill);

export const skill = (
    state = Immutable.fromJS({ records: {} }),
    action: ActionType
) => {
    //Override with switch cases if we need to override
    switch (action.type) {
        case SkillActions.types.ADD_ENTITY_SUCCESS: {
            const { entity, params } = action;
            if (!entity) {
                throw new Error('expected action to have entity');
            }
            const { clientId } = params;

            const updatedSkill = Skill.fromJS(entity);

            const entities = state.getIn([
                'records',
                clientId,
                'entities',
                'records'
            ]);
            let newState = state;
            if (entities) {
                const updatedSkills = entities.concat(updatedSkill);

                newState = newState.setIn(
                    ['records', clientId, 'entities', 'records'],
                    updatedSkills
                );
            }

            return newState;
        }
    }
    return baseReducer(state, action);
};
